/*
4. Add payment amount to server and frontend.
5. Add payment with card through paypal.
6. Add more payment details to server and frontend.
*/

import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';
import Home from './Pages/Home/Home';
import About from "./Pages/About/About";
import Donate from './Pages/Donate/Donate';

const App = ({URLS, PAYMENTS, RECURRING_PERIODS}) => {
  return (
    <Router>
      <Routes>
        <Route path={URLS.Home} element={<Home URLS={URLS}/>}/>
        <Route path={URLS.About} element={<About URLS={URLS}/>}/>
        <Route path={URLS.Checkout} element={<Donate
            URLS={URLS}
            paymentAmounts={PAYMENTS}
            recurringPeriods={RECURRING_PERIODS}/>}/>
        <Route path={"*"} element={<Home URLS={URLS}/>}/>
      </Routes>
    </Router>
  );
};

export default App;
